module.exports = __webpack_public_path__ + "static/img/9.dae0b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/9.jpg
// module id = qJL8
// module chunks = 0